import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import MasterBase from "../components/MasterLayout";
import { readonly } from '../modules/formstore';
import { isEmpty, getformid, getcontroller, getsubkey } from '../modules/appLibrary';

export const List = props => {

    const menus = useSelector(state => state.menu.menus);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const dispatch = useDispatch();
    const formid = getformid("List", props.location.search);
    const controller = getcontroller("List", props.location.search);
    const subkey = getsubkey(props.location.search);
    const search = useLocation().search;
    const [noclear, setnoclear] = useState(false);

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]
    //動作抑止
    const suppressaction = [
    ];
    const actionurl = {
        "getlist": "list/GetList",
    }

    useEffect(() => {
        var menu = menus.find(e => e.id === controller);
        if (isEmpty(menu)) dispatch(readonly({ readonly: false, ctrls: "" }));
        else dispatch(readonly({ readonly: menu.ro, ctrls: menu.ctrls }));
    }, [menus, search]);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setnoclear(menuinfo.ctrls.indexOf("NOCLEAR") !== -1);
    }, [menuinfo]);

    return (
         <div>
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                condition={true}
                navmenu={navmenu}
                suppressaction={suppressaction}
                list={true}
                noclear={noclear}
            />
        </div>
    );
};
